<template>
  <div class="c-message c-message--membership c-content" data-message-type="membership">
    <template v-if="isLoading">
      <div class="loader" ><i class="fal fa-circle-notch fa-spin" aria-hidden="true"></i> Loading</div>
    </template>
    <template v-else>
      <div class="c-message__head">
        <h3 class="c-col__heading-4"><i class="fal fa-unlock"></i> Member Booking</h3>
      </div>
      <div class="c-message__flash c-boxout c-boxout--error" :class="{ 'c-boxout--success' : messageAlertSuccessStatus }" v-if="messageFlash.length > 0" v-html="messageFlash"></div>
      <div class="c-message__content " v-html="output"></div>
      <Modal />
    </template>
  </div>
</template>

<script>
import {mapState} from "vuex"
import _ from "lodash"
import {EventBus} from "../../event-bus"
import Modal from "../Modal"

export default {
  name: "Membership",
  props: ['content'],
  components: {
    Modal,
  },
  data() {
    return {
      isLoading: true,
      output: '',
      messageFlash: '',
      messageAlertSuccessStatus: false,
      modalContent: {},
      messageAlert: {
        unlocked: 'As a member you are now able to book tickets for this show.',
        unlockedByAddingToBasket: 'Membership added to basket. You are now able to book tickets for this show.',
        locked: 'Member bookings open soon. Please see the booking dates below for more information.',
      }
    }
  },
  computed: {
    ...mapState({
      mos: state => state.mos.membership,
      isLoggedIn: state => state.isLoggedIn,
      thirdPartyData: state => state.thirdPartyData
    }),
    loginLink() {
      return `${window.env.TNEW_BASE_URL}/account/login?ReturnUrl=${encodeURI(window.location)}`
    }
  },
  mounted() {
    EventBus.$on('eventData:loaded', this.renderContent)
    EventBus.$on('thirdPartyData:loaded', this.renderContent)

    // This is required as loading state spins when no picker or third party check is required
    // In reality the message for membership wouldn't be used with some form of MOS check
    EventBus.$on('noDataRequired', this.renderContent)

    EventBus.$on('membership-added-to-basket--success', () => {
      this.messageFlash = this.messageAlert.unlockedByAddingToBasket
      this.messageAlertSuccessStatus = true
      const modalTrigger = document.querySelectorAll('[data-modal-membership-levels]')
      if (modalTrigger) {
        modalTrigger.forEach(button => {
          button.style.display = 'none'
        })
      }

    })
    this.addModalTriggerEventForUpsells()
  },
  methods: {
    addModalTriggerEventForUpsells() {
      this.on('#iteration-messages', 'click', '[data-modal-membership-levels]', e => {
        e.preventDefault()
        const membershipLevels = JSON.parse(e.target.dataset.modalMembershipLevels)
        if (membershipLevels) {
          const stringifyMembershipLevels = JSON.stringify(membershipLevels)
          if (this.modalContent[stringifyMembershipLevels] !== undefined) {
            EventBus.$emit('open-modal', this.modalContent[stringifyMembershipLevels])
          } else {

            fetch(`${window.ajax.url}?${new URLSearchParams({
              action: 'basethemeMembershipUpsellsModalContent',
              membershipLevels: stringifyMembershipLevels,
            })}`)
                .then(response => response.json())
                .then(data => {
                  this.modalContent[stringifyMembershipLevels] = data.modalContent
                  EventBus.$emit('open-modal', data.modalContent)
                })
                .catch(error => console.log(error))
          }
        }


      })
    },
    currentModeOfSale() {
      if (window.ModeOfSaleId !== window.env.DEFAULT_MOS) {
        return parseInt(window.ModeOfSaleId)
      }
      return parseInt(window.env.DEFAULT_MOS)
    },
    displayLogInLink() {
      // Only display if not logged in or the current MOS is not a membership MOS
      return !this.isLoggedIn || !this.mos.includes(this.currentModeOfSale())
    },
    validMos() {
      if (document.querySelector('[data-booking-button-type="picker"]')) {
        return Object.values(this.mos).map(x => parseInt(x)).includes(this.currentModeOfSale()) && this.mosAvailable()
      } else if (document.querySelector('[data-booking-button-type="third-party"]')) {
        return this.thirdPartyData.validMos
      }

      return false
    },
    mosAvailable() {
      let available = false
      const currentModeOfSale = this.currentModeOfSale()
      this.$store.state.eventData.instances.every(instance => {
        if (_.map(instance.prices, p => parseInt(p.mos)).includes(currentModeOfSale)) {
          if((_.filter(instance.prices, (p) => {
            return p.percentage !== '0%' && parseInt(p.mos) === currentModeOfSale
          })).length > 0) {
            available = true
            return false
          }
        }

        return true
      })

      return available
    },
    renderContent() {
      this.output = this.content.message
      if (document.querySelector('[data-booking-button]')) {
        if (this.isLoggedIn && this.validMos()) {
          this.output = ''
          this.messageAlertSuccessStatus = true
          this.messageFlash = this.messageAlert.unlocked
        } else  {
          this.messageAlertSuccessStatus = false

          // Display locked message for mode of sale that is not default
          // and amex message not present
          if (!document.body.classList.contains('amex-message-output') && this.currentModeOfSale() !== 11) {
            this.messageFlash = this.messageAlert.locked
          }

        }

      }
      this.isLoading = false
    },
    on(selector, eventType, childSelector, eventHandler) {
      const elements = document.querySelectorAll(selector)
      for (let element of elements) {
        element.addEventListener(eventType, eventOnElement => {
          if (eventOnElement.target.matches(childSelector)) {
            eventHandler(eventOnElement)
          }
        })
      }
    },

  }
}
</script>
